import React, { useState, useEffect } from "react";
import { Grid, Typography, Box, alpha, CircularProgress } from "@mui/material";
import CardContactanos from "./CardContactanos";
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from "../../../firebase/firebaseConfig";

const logoStyle = {
    width: { xs: '60%', sm: '40%', md: '20%' },  // Tamaño variable
    height: 'auto',
    cursor: 'pointer',
    borderRadius: '50%',
    border: '1.5px solid #f1f1f1',
};

const ContactPages = () => {
    const [infoContactanos, setInfoContactanos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const unsubscribe = onSnapshot(
            collection(db, 'pagecontactanoscalocho'),
            (snapshot) => {
                const arregloInfoContactanos = snapshot.docs.map((docInfoContactanos) => ({
                    ...docInfoContactanos.data(), id: docInfoContactanos.id
                }));
                setInfoContactanos(arregloInfoContactanos);
                setLoading(false);
            },
            (error) => {
                console.log(error);
                setLoading(false);
            }
        );
        return () => unsubscribe();
    }, []);

    // Carrusel: Actualizar el índice cada 10 segundos
    useEffect(() => {
        if (infoContactanos.length > 1) {
            const interval = setInterval(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % infoContactanos.length);
            }, 10000); // 10000ms = 10s
            return () => clearInterval(interval);
        }
    }, [infoContactanos.length]);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress sx={{ color: '#5d0303' }} />
            </Box>
        );
    }

    if (infoContactanos.length === 0) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Typography variant="h6">No hay datos por mostrar</Typography>
            </Box>
        );
    }

    return (
        <Box sx={(theme) => ({
            width: '100%',
            backgroundImage:
              theme.palette.mode === 'light'
                ? 'linear-gradient(180deg, #5d0303, #FFF)'
                : `linear-gradient(#02294F, ${alpha('#090E10', 0.0)})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            padding: { xs: 2, sm: 4, md: 8 },
        })}>
                <Grid item key={infoContactanos[currentIndex].id} alignItems="center" justifyContent="center" sx={{
                    p: { xs: 2, sm: 4, md: 6 },
                    m: { xs: 0, sm: 3, md: 4 },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    <Box sx={{
                        mb: 1,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: {
                            xs: 'column',
                            sm: 'row'
                        },
                        gap: { xs: 2, sm: 3, md: 4 }
                    }}>
                        <Grid alignItems="center" justifyContent="center" sx={{ p: 4, m: 4, display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="h2" sx={{
                                marginBottom: { xs: '5%', sm: '3%' },
                                textAlign: 'center',
                                fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' }
                            }}>{infoContactanos[currentIndex].titulo}</Typography>
                            <Typography variant="subtitle1" sx={{
                                marginBottom: { xs: '5%', sm: '3%' },
                                textAlign: 'center',
                                fontSize: { xs: '1rem', sm: '1.2rem', md: '1.4rem' }
                            }}>{infoContactanos[currentIndex].subtitulo}</Typography>
                            <Typography variant="subtitle1" sx={{
                                marginBottom: { xs: '5%', sm: '3%' },
                                textAlign: 'center',
                                fontSize: { xs: '0.9rem', sm: '1.1rem', md: '1.2rem' }
                            }}>{infoContactanos[currentIndex].descripcion}</Typography>
                            <Typography variant="subtitle1" sx={{
                                marginBottom: { xs: '5%', sm: '3%' },
                                textAlign: 'center',
                                fontSize: { xs: '0.9rem', sm: '1.1rem', md: '1.2rem' }
                            }}>{infoContactanos[currentIndex].descripcion2}</Typography>
                            <Grid sx={{ display: 'flex' }} justifyContent={'center'}>
                                <img src={infoContactanos[currentIndex].imagen} className="imagen-con-animacion" alt="Contacto" style={logoStyle} />
                            </Grid>
                        </Grid>
                        <CardContactanos />
                    </Box>
                </Grid>
        </Box>
    );
}

export default ContactPages;